import { memo, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import Paiement from '../../components/paiement/Paiement'
import Skeleton from '@material-ui/lab/Skeleton'
import { Checkbox, Button, Alert, RadioGroup, FormLabel, FormControlLabel, FormControl, Radio } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../redux/actions/user'
import ReglementModal from './ReglementModal'

import { PaymentMultiple } from '../../components/PaymentMultiple'

export default memo(({ classes, panier, finalData }) => {

  const state = useSelector(state => state)
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()

  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  const [reglementModal, setReglementModal] = useState(false)
  const [reglementAccept, setReglementAccept] = useState(false)

  const [form, setForm] = useState(<></>)
  const [formReady, setFormReady] = useState(false)
  const [submitButton, setSubmitButton] = useState(null)
  const [modePaiement, setModePaiement] = useState('unefois')
  const [isAnneeSaison, setIsAnneeSaison] = useState(false)


  useEffect(async () => {

    const listCours = finalData.activite.map(item => ({
      liID: item.licencie.id,
      liMail: state.user.mail,
      centre: item.centre.CNT_ID,
      category: item.periode.prices.TAR_CAT_ID || item.periode.prices.CAT_ID,
      typeAbo: getTypeCarteID(item),
      cours: item.crenaux?.CO_ID,
      dateDeb: item.periode.dates.DATE_DEBUT,
      dateFin: item.periode.dates.DATE_FIN,
      periode: getTypePeriodeID(item),
      activity: item.activite.ACT_ID,
      activityName: item.activite.ACT_LIBELLE,
      montant: getItemPrice(item)
    }))

    for (const cours of listCours) {

      if ((cours.periode === 3 && !state.interruptionX10) || cours.periode === 4)
        setIsAnneeSaison(true)
      else
        setIsAnneeSaison(false)

    }
    const payload = {
      'amount': Math.round(finalData.total * 100),
      'currency': 'EUR',
      //'ipnTargetUrl': 'https://7695-213-44-182-19.eu.ngrok.io/api/new-souscription/insertAll',
      'ipnTargetUrl': process.env.REACT_APP_API_PATH + 'api/new-souscription/insertAll',
      'orderId': `souscription - ${state.user.numero}`,
      'customer': {
        'email': state.user.mail,
        'reference': state.user.numero,
        'billingDetails': {
          'firstName': state.user.prenom,
          'lastName': state.user.nom,
          'phoneNumber': state.user.additionalInfos?.LICI_TEL
        },
        'shoppingCart': {
          'cartItemInfo': finalData.activite.map(item => ({
            'productLabel': `${item.activite.ACT_LIBELLE} - ${item.periode.libelle} - ${item.licencie.numero}`,
          }))
        }
      },
      'metadata': {
        'cours': JSON.stringify(listCours)
      }
    }

    setForm(<Paiement
      reload={new Date()}
      payload={payload}
      callback={paymentCallback}
      onReady={() => { setFormReady(true) }}
      onRemove={() => { setFormReady(false) }}
    />)

  }, [])

  function getTypeCarteID(item) {
    // Tennis liberté
    if (item.activite.ACT_ID === '7F8D84B4-C9F5-40E4-B8B3-FE69CB2B3803') return 3

    // carte passeport ou item de la carte passeport
    if (item.passeport) return 2

    // solo et solo +
    return 1
  }

  function getTypePeriodeID(item) {
    switch (item.periode.libelle) {
      case 'mois': return 1
      case 'trimestre': return 2
      case 'saison': return 3
      case 'annee': return 4
    }
  }

  function getItemPrice(item) {

    // Si c'est une carte passeport
    if (item.passeport) return item.price

    // Si c'est un item de la carte passeport
    if (item.isInPasseport) return 0

    // Si autre
    return item.periode.price
  }

  useEffect(() => {
    if (formReady) {
      const btn = document.querySelector('.kr-payment-button')
      
      if (btn) {
        btn.dataset.disabled = !reglementAccept
        btn.addEventListener('focus', (event) => {
          event.target.blur()
        }, true)
      }
      setSubmitButton(btn)
    }
  }, [formReady])

  useEffect(() => {
    if (submitButton) submitButton.dataset.disabled = !reglementAccept
  }, [reglementAccept])

  async function paymentCallback(success) {

    // Vérification que la souscription s'est bien effectué
    const body = {
      activites: panier.map(item => item.activite.ACT_ID),
      liciencies: panier.map(item => item.licencie.id)
    }
    const { json } = await allActions.fetchPostAPI('api/new-souscription/just-subscribe', body, dispatch, token)

    if ((json.data?.length ?? 0) >= panier.length) {
      enqueueSnackbar('Souscription validé', { variant: `success` })
    } else {
      let err_text = ''
      if ((json.data?.length ?? 0) == 0) err_text = 'votre souscription n\'a pas pu être enregistré.'
      else err_text = 'certaines souscriptions n\'ont pas pu être enregistrés.'
      enqueueSnackbar(`Une erreur est survenu, ${err_text}`, { variant: `error` })
    }

    if (success) history.push('/mes-activites')
  }

  return (
    <div className={classes.paiement}>
      <Alert
        severity="info"
        sx={{ marginTop: '8px!important' }}
        icon={<Checkbox sx={{ padding: 0 }} disableRipple value={reglementAccept} onChange={(e) => setReglementAccept(e.target.checked)} />}
      >
        Accepter le
        <Button
          size="small"
          sx={{ margin: '0 4px', minWidth: 'fit-content', padding: '0' }}
          onClick={() => setReglementModal(true)}
        >
          règlement intérieur
        </Button>
      </Alert>
      {isAnneeSaison && (
        <FormControl style={{ marginBlock: 12 }}>
          <div style={{ fontWeight: 'bold', color: 'rgb(0, 88, 178)' }}>Mode de paiement</div>
          {/* <FormLabel id="demo-row-radio-buttons-group-label" style={{ fontWeight: 'bold' }}>Mode de paiement</FormLabel> */}
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            onChange={(e) => setModePaiement(e.target.value)}
            value={modePaiement}>
            <FormControlLabel control={<Radio value="unefois" />} label="Payer en 1 fois" />
            <FormControlLabel control={<Radio value="dixfois" />} label="Payer en 10 fois" />
          </RadioGroup>
        </FormControl>
      )}


      <div >
        {modePaiement === 'unefois'
          ? <div style={{ height: formReady ? 'auto' : 0, overflow: 'hidden' }}>{form}</div>
          : <PaymentMultiple finalData={finalData} disabled={!reglementAccept} />
        }
      </div>

      <div style={{ display: formReady ? 'none' : 'block', marginTop: 16 }}>
        <Skeleton variant="rect" height="66px" style={{ borderRadius: 4, marginBottom: 14 }} />
        <Skeleton variant="rect" height="40px" style={{ borderRadius: 4, marginBottom: 16 }} />
        <Skeleton variant="rect" height="40px" style={{ borderRadius: 4, marginBottom: 16 }} />
        <Skeleton variant="rect" height="40px" style={{ borderRadius: 4, marginBottom: 16 }} />
        <Skeleton
          variant="rect"
          height="48px"
          width="100%"
          style={{ borderRadius: 4, color: 'white', fontWeight: 500, display: 'grid', placeItems: 'center', fontFamily: 'Roboto, Helvetica, Arial, sans-serif', fontSize: '14px' }}
        >
          CHARGEMENT ...
        </Skeleton>
      </div>




      <ReglementModal
        classeName={classes.modal}
        reglementModal={reglementModal}
        setReglementModal={setReglementModal}
      />

    </div>
  )
})